import React, { useState } from 'react';
import { translate } from '../Services/translation';

const RemoveButton = ({ onClick }) => {
  const [popupOpen, setPopupOpen] = useState(false);
  return (
    <>
      <a
        className="checkout-cart__delete"
        onClick={() => setPopupOpen(true)}
        title={translate('general.remove')}
      >
        <svg>
          <use href="/ui/images/sprites/brenderup.svg#delete"></use>
        </svg>
      </a>
      {popupOpen && (
        <>
          <div className="popup">
            <div className="popup__inner">
              <a
                className="popup__inner--close"
                onClick={() => setPopupOpen(false)}
                title={translate('general.cancel')}
              >
                <svg>
                  <use href="/ui/images/sprites/brenderup.svg#close"></use>
                </svg>
              </a>

              <div className="cart__popupComment delete-product">
                <h3 className="cart__popupComment--label">
                  {translate('shoppinglist.removefromshoppinglistheader')}
                </h3>
                <p>{translate('shoppinglist.removefromshoppinglist')}</p>
                <a
                  className="button popup__inner--button"
                  onClick={() => {
                    setPopupOpen(false);
                    onClick();
                  }}
                  title={translate('general.ok')}
                >
                  {translate('general.ok')}
                </a>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default RemoveButton;
